import { render, staticRenderFns } from "./MaterialFolderSelectDialog.vue?vue&type=template&id=25e5eba2&scoped=true"
import script from "./MaterialFolderSelectDialog.vue?vue&type=script&lang=ts"
export * from "./MaterialFolderSelectDialog.vue?vue&type=script&lang=ts"
import style0 from "./MaterialFolderSelectDialog.vue?vue&type=style&index=0&id=25e5eba2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25e5eba2",
  null
  
)

export default component.exports